module.exports = __webpack_public_path__ + "img/user-nav-ljdd-icon.0746b897.png";